const toIsoDate = date =>
  date.toISOString().split('T', 1)[0];

export default toIsoDate;